import { render, staticRenderFns } from "./jtjs.vue?vue&type=template&id=459abf54&scoped=true&"
import script from "./jtjs.vue?vue&type=script&lang=js&"
export * from "./jtjs.vue?vue&type=script&lang=js&"
import style0 from "./jtjs.vue?vue&type=style&index=0&id=459abf54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459abf54",
  null
  
)

export default component.exports